<template>
  <v-system-bar
    v-if="showTotpBanner"
    class="text-body-2 totp-notification"
    color="warning"
    height="36"
  >
    <v-container class="align-center d-flex justify-center">
      {{ t('messages.enable2FaToSecureYourAccount') }}
      <v-btn
        v-if="accountUrl"
        :append-icon="mdiOpenInNew"
        class="ml-4"
        :href="accountUrl"
        size="x-small"
        target="_blank"
        :text="t('messages.activate')"
        variant="tonal"
      />
    </v-container>
  </v-system-bar>
</template>

<script lang="ts" setup>
import { mdiOpenInNew } from '@mdi/js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { createAccountUrl, keycloak } from '@abaninja/util-keycloak';

const { t } = useI18n();

const showTotpBanner = computed(() => keycloak?.tokenParsed && !keycloak.tokenParsed.totp);

const accountUrl = createAccountUrl();
</script>

<style lang="postcss" scoped>
@media print {
  .totp-notification{
    display: none;
  }
}
</style>
